function isValidCoordinate(value, min, max) {
  return typeof value === 'number' && Number.isFinite(value) && value >= min && value <= max
}

export function normalizeBounds(minLatitude, maxLatitude, minLongitude, maxLongitude) {
  const normalized = {
    minLatitude: Number(minLatitude),
    maxLatitude: Number(maxLatitude),
    minLongitude: Number(minLongitude),
    maxLongitude: Number(maxLongitude),
  }

  const isValid =
    isValidCoordinate(normalized.minLatitude, -90, 90) &&
    isValidCoordinate(normalized.maxLatitude, -90, 90) &&
    isValidCoordinate(normalized.minLongitude, -180, 180) &&
    isValidCoordinate(normalized.maxLongitude, -180, 180) &&
    normalized.minLatitude < normalized.maxLatitude &&
    normalized.minLongitude < normalized.maxLongitude

  return isValid ? normalized : null
}

export function createBoundsFeature(bounds) {
  if (!bounds) return { type: 'Sphere' }

  const { minLatitude, maxLatitude, minLongitude, maxLongitude } = bounds

  return {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [[
        [minLongitude, minLatitude],
        [minLongitude, maxLatitude],
        [maxLongitude, maxLatitude],
        [maxLongitude, minLatitude],
        [minLongitude, minLatitude],
      ]],
    },
  }
}

function getNumericRange(values) {
  return values.reduce(
    (acc, value) => {
      if (value < acc.min) acc.min = value
      if (value > acc.max) acc.max = value
      return acc
    },
    { min: Infinity, max: -Infinity }
  )
}

function createPointBoundsFeature(points) {
  if (!points.length) return { type: 'Sphere' }

  const longitudeRange = getNumericRange(points.map((point) => point.__pointMapLongitude))
  const latitudeRange = getNumericRange(points.map((point) => point.__pointMapLatitude))
  const longitudePadding = Math.max(4, (longitudeRange.max - longitudeRange.min || 0) * 0.25)
  const latitudePadding = Math.max(4, (latitudeRange.max - latitudeRange.min || 0) * 0.25)

  return createBoundsFeature(
    normalizeBounds(
      Math.max(-90, latitudeRange.min - latitudePadding),
      Math.min(90, latitudeRange.max + latitudePadding),
      Math.max(-180, longitudeRange.min - longitudePadding),
      Math.min(180, longitudeRange.max + longitudePadding)
    )
  )
}

export function getViewportFeature(viewMode, data, visualOptions) {
  if (viewMode === 'Custom bounds') {
    const bounds = normalizeBounds(
      visualOptions.minLatitude,
      visualOptions.maxLatitude,
      visualOptions.minLongitude,
      visualOptions.maxLongitude
    )
    return createBoundsFeature(bounds)
  }

  if (viewMode === 'Fit to data' && data.length) {
    return createPointBoundsFeature(data)
  }

  return { type: 'Sphere' }
}
